import React from 'react';

const SEO = ({ location, titleTag, index, metaDescription, metaImageUrl, metaImageWidth, metaImageHeight, schema }) => {
  const url = process.env.SITE_URL;
  return (
    <>
      {/* SEO */}
      {titleTag ? (
        <title>{`${titleTag} | Lillio`}</title>
          ) : (
        <title>{'Lillio'}</title>)
      }
      {metaDescription && <meta name='description' content={metaDescription}/>}

      {/* Twitter */}
      {titleTag && <meta name='twitter:title' content={titleTag} />}
      {metaDescription && <meta name='twitter:description' content={metaDescription} /> }
      {metaImageUrl && <meta property='twitter:image' content={metaImageUrl} /> }
      <meta name='twitter:card' content='summary_large_image' />

      {/* Meta OG */}
      {titleTag && <meta property='og:title' content={titleTag} />}
      {metaDescription && <meta property='og:description' content={metaDescription} /> }
      {location && <meta property='og:url' content={`${url}${location?.pathname}`} />}
      {metaImageUrl && <meta property='og:image' content={metaImageUrl} />}
      {metaImageWidth && <meta property='og:image:width' content={metaImageWidth} />}
      {metaImageHeight && <meta property='og:image:height' content={metaImageHeight} />}
      <meta property='og:type' content='article' />

      {/* No Index */}
      {!index && <meta name='robots' content='noindex'/>}

      {/* Schema */}
      {schema?.internal?.content && <script type='application/ld+json'>{schema.internal.content}</script>}

      {(location?.pathname === '/') &&
        <>
          {/* Bing Validation */}
          <meta name='msvalidate.01' content='E02B9F6B5968778B741C3F952CB85EB5' />
        </>
      }
    </>
  )
}

export default SEO
